import React from "react";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Iban from "../components/Iban";

import ImageList from "@mui/material/ImageList";
import ImageListItem from "@mui/material/ImageListItem";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: "#fff",
  fontFamily: '"Penna"',
  fontSize: "1.8rem",
  fontWeight: "bold",
}));

function Lista() {
  return (
    <Container maxWidth="xl" sx={{ pt: "1em" }}>
      <Box sx={{ width: "100%" }}>
        <Stack spacing={0}>
          <Item sx={{ backgroundColor: "transparent" }}>
            <Grid
              container
              rowSpacing={1}
              columnSpacing={{ xs: 1, sm: 2, md: 3 }}
              direction="row"
              justifyContent="center"
              alignItems="flex-start"
              textAlign="left"
            >
              <Grid item xs={12} sm="none" md="none">
                <span style={{ height: "10px", display: "block" }}>&nbsp;</span>
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography
                  variant="body1"
                  color="text.primary"
                  align="left"
                  sx={{
                    fontFamily: '"Penna"',
                    fontSize: "1.8rem",
                    fontWeight: "bold",
                    color: "#fff",
                  }}
                >
                  Vista la nostra passione per i viaggi, il regalo piu' grande
                  che possiate farci, oltre alla vostra presenza, e' contribuire
                  al nostro viaggio di nozze. Per spedirci molto lontano, questo
                  e' il nostro IBAN:
                </Typography>
                <Iban />
              </Grid>
            </Grid>
            <ImageList variant="masonry" cols={2} gap={8}>
              <ImageListItem>
                <img
                  srcSet={`IMG_6259.jpg`}
                  src={`IMG_6259.jpg`}
                  alt={""}
                  loading="lazy"
                />
              </ImageListItem>
              <ImageListItem>
                <img srcSet={`2.jpg`} src={`2.jpg`} alt={""} loading="lazy" />
              </ImageListItem>
              <ImageListItem>
                <img
                  srcSet={`IMG-20241119-WA0024.jpg`}
                  src={`IMG-20241119-WA0024.jpg`}
                  alt={""}
                  loading="lazy"
                />
              </ImageListItem>
              <ImageListItem>
                <img
                  srcSet={`IMG_1974.jpg`}
                  src={`IMG_1974.jpg`}
                  alt={""}
                  loading="lazy"
                />
              </ImageListItem>
              <ImageListItem>
                <img
                  srcSet={`IMG_1.jpeg`}
                  src={`IMG_1.jpeg`}
                  alt={""}
                  loading="lazy"
                />
              </ImageListItem>
            </ImageList>
          </Item>
        </Stack>
      </Box>
    </Container>
  );
}

export default Lista;
